import React, {Component} from 'react';
import { Formik, Form, Field } from 'formik';
import _ from 'underscore';
import {
    Grid,
    Button,
    Message,
} from 'semantic-ui-react';
import {connect} from 'react-redux';

import FormsInputsDropdown from '../../inputs/dropdownbank/index';
import FormsInputsText from '../../inputs/text/forms_inputs_text';
import FormsInputsNumber from '../../inputs/number/forms_inputs_number';
import UpdateBankSchema from './validation';
import BankUtility from '../../../../utils/bankUtility/BankUtility';
import { getBankOptions } from '../../../../actions';

const BANK_ACCOUNT_INFO_GUIDE_URL = 'https://incomeapp.mhc.asia/static/BankAccountInformationGuideforGIROPayment.pdf'
const FLAG_BRANCH_NOT_SELECTED = "BRANCH_NOT_SELECTED"
// const prepareBankOrBranchListOptions = (list) => {
//     return _.map(list, (item, index) => {
//         return { text: item.n, value: item.c, key: index};
//     });
// }


const prepareBankListOptions = (list) => {
    return _.map(list, (item, index) => {
        return { text: item.n, value: item.n, key: index};
    });
}

const prepareBranchListOptions = (list, bankName) => {
    for (var i=0; i< list.length; i++) {
        if(list[i].n.toLowerCase() === bankName.toLowerCase()){
          let branchList = _.map(list[i].branches, (item, index) => {
              return { text: item.n, value: item.c, key: index};
          });
          branchList.unshift({ text: "-- Please Select Branch --", value: FLAG_BRANCH_NOT_SELECTED})
          return branchList;
        }
    }
}

const getBankName = (list, bankNo, accountNo) => {
    //alert(number, list);
    for(var i=0; i<list.length; i++){
        if(list[i].c === bankNo){
          if (accountNo.length === 9){
              return 'POSBank'
          }
          return list[i].n;
        }
    }
}

const getBankNo = (list, bankName) => {
    //alert(number, list);
    for(var i=0; i<list.length; i++){
        if(list[i].n.toLowerCase() === bankName.toLowerCase()){
          return list[i].c;
        }
    }
}

class FormsUpdateBankAccount extends Component {

    bankUtility = new BankUtility();

    state = {
        error: false,
        errorMessage: null,
        success: false
    }

    componentWillMount(){
        if(!this.props.appConfig.bankList.blV2){
            this.props.getBankOptions();
        }
    }

    renderFormSubmissionResult() {
        if (this.state.success === true) {
            return (
                <Grid.Column width={16}>
                    <Message positive floating>
                        <Message.Header>Bank Account Changed Successfully!</Message.Header>
                    </Message>
                </Grid.Column>
            );
        }
        if (this.state.error === true) {
            return (
                <Grid.Column width={16}>
                    <Message negative>
                        <Message.Header>We're sorry - there was an issue with the change</Message.Header>
                        <p>
                            { this.state.errorMessage }
                        </p>
                    </Message>
                </Grid.Column>
            );
        }
    }

    onBankNameChange(evt, formikData){
        let bankName = formikData.field.value;
        let accountNo = formikData.values.accountNo;
        let accountNoConfirm = formikData.values.accountNoConfirm;
        formikData.setFieldValue("bankName", bankName);

        // auto select branch
        this.selectBranch(bankName, accountNo, accountNoConfirm, formikData);
    }

    onBankAccountChange(evt, formikData){
        try{
            let bankName = formikData.values.bankName;
            let accountNo = evt.target.name === "accountNo" ? evt.target.value : formikData.values.accountNo;
            let accountNoConfirm = evt.target.name === "accountNoConfirm" ? evt.target.value : formikData.values.accountNoConfirm;
    
            // validate number
            accountNo = accountNo.replace(/\D+/g, '');
            accountNoConfirm = accountNoConfirm.replace(/\D+/g, '');
    
            // set the filtered value to responsible variable
            if(evt.target.name === "accountNo"){
                formikData.setFieldValue("accountNo", accountNo);
            }else if(evt.target.name === "accountNoConfirm"){
                formikData.setFieldValue("accountNoConfirm", accountNoConfirm);
            }

            // auto select branch
            this.selectBranch(bankName, accountNo, accountNoConfirm, formikData);
            
        }catch(err){
            console.error(err);
        }
    }

    selectBranch(bankName, accountNo, accountNoConfirm, formikData){
        try{
            const bankNo = getBankNo(formikData.bankList, bankName);
            const branchCode = this.bankUtility.getBranchCode(bankNo, accountNo);
            const bankInUI = formikData.bankList.find( bank => bank.c === bankNo );
            const branchInUI = bankInUI.branches.find( branch => branch.c === branchCode );

            // General validation for account no digit
            this.bankUtility.isValidAccountNoDigit(bankNo, accountNo);


            
            // Populate UI
            // Handle Bank of China
            if( bankNo === "7083" && accountNo === accountNoConfirm ){
                formikData.setFieldValue("branchNo", "011");
                formikData.setFieldValue("accountNo", this.bankUtility.getAccountNo(bankNo, accountNo) || accountNo);
                formikData.setFieldValue("accountNoConfirm", this.bankUtility.getAccountNo(bankNo, accountNoConfirm) || accountNoConfirm);
            }
            else if( branchCode && branchInUI && (accountNo === accountNoConfirm)){

                if( ["7339", "7232", "9548", "7991"].includes(bankNo) ){
                    window.alert("Please note that the first 3 digits of the Account No is dropped and used as the Branch Code");
                }

                formikData.setFieldValue("branchNo", branchCode);
                formikData.setFieldValue("accountNo", this.bankUtility.getAccountNo(bankNo, accountNo) || accountNo);
                formikData.setFieldValue("accountNoConfirm", this.bankUtility.getAccountNo(bankNo, accountNoConfirm) || accountNoConfirm);
            }else{
                throw new Error("Branch not found");
            }
        }catch(err){
            formikData.setFieldValue("branchNo", FLAG_BRANCH_NOT_SELECTED);
        }
    }

    render() {

        if(!this.props.appConfig.bankList.blV2){
            return <p>Loading ...</p>;
        }
        const { bbl, bl, blV2 } = this.props.appConfig.bankList;
        var _bankName = this.props.user.bankDetail && this.props.user.bankDetail.length > 0? getBankNo(blV2, this.props.user.bankDetail.bankName) : ''

        return (
            <Formik
                initialValues={{
                    bankName: this.props.user.bankDetail.bankName || '',
                    bankNo: _bankName || '',
                    accountNo: this.props.user.bankDetail.accountNo || '',
                    accountNoConfirm: this.props.user.bankDetail.accountNo || '',
                    branchNo: this.props.user.bankDetail.branchNo || ''
                }}
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={UpdateBankSchema}
                validate={(values) => {
                    // Additional Validation (if any)
                    let error = {};
                    if (values.accountNo !== values.accountNoConfirm) {
                        error.accountNoConfirm = 'Account Numbers do not match.'
                    }
                    return error;
                }}
                onSubmit={(values, actions) => {
                    console.log(values, actions);
                    var _bankNo = getBankNo(blV2, values.bankName)
                    this.props.updateUserProfileInformation({data: {bankNo:_bankNo, accountNo:values.accountNo, branchNo:values.branchNo, bankName:values.bankName}, accessToken: this.props.user.accessToken}, (result, error) => {
                        console.log('done');
                        if (error) {
                            console.log('done-failed');
                            //actions.resetForm();
                            actions.setSubmitting(false);
                            this.setState({error: true, success: false, errorMessage: error.errorMessage});
                        }
                        if (result) {
                            console.log('done-success');
                            const bankName = values.bankName;
                            const branchNo = _bankNo;
                            const accountNo = values.accountNo;
                            actions.resetForm();
                            values.bankNo = bankName;
                            values.branchNo = branchNo;
                            values.accountNo = accountNo;
                            actions.setSubmitting(false);
                            this.setState({error: false, success: true, errorMessage: null});
                        }
                    });
                }}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                }) => (
                    <Form style={{paddingBottom: 20, paddingTop: 20}}>
                        Please update your bank account details here if you prefer us to reimburse your medical claim via direct credit. Please note that this bank account will not be used for other purposes.
                        <br/>
                        <br/>
                        To avoid delay in payment due to an invalid bank account number, please click <a href={BANK_ACCOUNT_INFO_GUIDE_URL} target='blank'>here</a> to view the guide on keying of bank account number and branch code.
                        <br/>
                        <br/>
                        <br/>

                        <Grid columns={2}>
                            <Grid.Column width={16}>
                            {
                                (this.props.user.bankDetail.bankName === null || this.props.user.bankDetail.bankName === "") && (
                                <Field
                                    name="bankName"
                                    label="Bank"
                                    component={FormsInputsDropdown}
                                    secondaryLabel=""
                                    options={prepareBankListOptions(blV2)}
                                    onChange={(e, formikField)=>{ this.onBankNameChange(e, {values, setFieldValue, bankList : blV2, field:formikField}) }}
                                />)
                            }
                            {
                                (this.props.user.bankDetail.bankName !== null && this.props.user.bankDetail.bankName !== "") && (
                                <Field
                                    name="bankName"
                                    label="Bank"
                                    component={FormsInputsText}
                                    secondaryLabel=""
                                    disabled={true}
                                />)
                            }
                            </Grid.Column>
                            <Grid.Column width={8}>
                                <Field
                                    name="accountNo"
                                    label="Account Number"
                                    component={FormsInputsText}
                                    secondaryLabel=""
                                    disabled={this.props.user.bankDetail.bankName !== null && this.props.user.bankDetail.bankName !== ""}
                                    onChange={(e, formikField)=>{ this.onBankAccountChange(e, {values, setFieldValue, bankList : blV2, field:formikField}) }}
                                />
                            </Grid.Column>
                            <Grid.Column width={8}>
                            {
                                (this.props.user.bankDetail.bankName === null || this.props.user.bankDetail.bankName === "") && (
                                <Field
                                    name="accountNoConfirm"
                                    label="Re-enter Account Number"
                                    component={FormsInputsText}
                                    secondaryLabel=""
                                    display={this.props.user.bankDetail.bankName === null || this.props.user.bankDetail.bankName === ""}
                                    onChange={(e, formikField)=>{ this.onBankAccountChange(e, {values, setFieldValue, bankList : blV2, field:formikField}) }}
                                />
                                )
                            }
                            </Grid.Column>

                            <Grid.Column width={16}>
                                {
                                    (this.props.user.bankDetail.bankName === null || this.props.user.bankDetail.bankName === "") && (
                                    <Field
                                        name="branchNo"
                                        label="Branch"
                                        component={FormsInputsDropdown}
                                        secondaryLabel=""
                                        options={(values.bankName) ? prepareBranchListOptions(blV2, values.bankName) : []}

                                    />)

                                }
                                {
                                    (this.props.user.bankDetail.bankName !== null && this.props.user.bankDetail.bankName !== "") && (
                                    <Field
                                        name="branchNo"
                                        label="Branch"
                                        component={FormsInputsText}
                                        secondaryLabel=""
                                        disabled={true}
                                    />)
                                }

                            </Grid.Column>


                            { this.renderFormSubmissionResult() }


                            <Grid.Column width={16}>
                            {
                                (this.props.user.bankDetail.bankName === null || this.props.user.bankDetail.bankName === "")&& (
                                <Button
                                    loading={isSubmitting}
                                    type="submit"
                                    primary
                                    disabled={isSubmitting}
                                    fluid
                                    size="big"
                                >
                                    Update my Bank Details
                                </Button>)
                            }
                            </Grid.Column>
                        </Grid>
                        <br/>
                        <br/>
                        The bank account details provided must be your bank account. Please note that if you provide us with an inaccurate bank account number, we shall discharge from all liability and not be liable for any losses incurred by you.
                    </Form>
                )}
            />
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user.user,
        appConfig: state.appConfig,
    }
}

export default connect(mapStateToProps,{
    getBankOptions
})(FormsUpdateBankAccount);
